import {CreateButtonProps} from "app/Interface/Component/Buttons"
import React from "react"
import {Button} from "react-bootstrap"
import {useTranslation} from "react-i18next"

function CreateButton({id, onClick, title, disabled}: CreateButtonProps) {
  const {t} = useTranslation('Components.Buttons')
  return (
    <Button
      id={`create-${id}`}
      onClick={onClick}
      disabled={disabled}
    >
      {t('create', {item: title})}
    </Button>
  )
}

export default CreateButton
